(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bundle-partner"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bundle-partner')) {
    class BundlePartner extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('.bp-js[hidden]').forEach((el) => el.removeAttribute('hidden'));
        if (this._bound) return;
        this._bound = true;
        this.addEventListener('click', (e) => {
          const btn = e.target.closest('[data-bp-add]');
          if (btn) this.addBoth(btn);
        });
      }

      labels() {
        try { return JSON.parse(this.getAttribute('data-labels') || '{}'); } catch (e) { return {}; }
      }

      toast(msg) {
        const el = this.querySelector('[data-bp-toast]');
        if (!el) return;
        el.textContent = msg;
        el.hidden = false;
        clearTimeout(this._t);
        this._t = setTimeout(() => { el.hidden = true; }, 5000);
      }

      async addBoth(btn) {
        // Read at click time: Horizon morphs this block when the variant changes.
        const mainId = parseInt(this.getAttribute('data-main-variant'), 10);
        const partnerId = parseInt(this.getAttribute('data-partner-variant'), 10);
        if (!mainId || !partnerId) return;
        const labels = this.labels();
        btn.disabled = true;
        try {
          let have = new Set();
          try {
            const cart = await fetch('/cart.js').then((r) => r.json());
            have = new Set((cart.items || []).map((i) => i.variant_id));
          } catch (e) {}
          const items = [];
          if (!have.has(mainId)) items.push({ id: mainId, quantity: 1 });
          if (!have.has(partnerId)) items.push({ id: partnerId, quantity: 1 });
          if (items.length) {
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: items }),
            });
            if (!res.ok) throw new Error('add failed');
          }
          this.toast(labels.added || '');
          try {
            const cart = await fetch('/cart.js').then((r) => r.json());
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: { resource: cart, sourceId: 'bundle-partner', data: { source: 'bundle-partner', itemCount: cart.item_count } },
            }));
          } catch (e) {}
          const drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.open === 'function') setTimeout(() => drawer.open(), 300);
        } catch (e) {
          this.toast(labels.error || '');
        }
        btn.disabled = false;
      }
    }
    customElements.define('bundle-partner', BundlePartner);
  }
  } catch(e) { console.error(e); }
})();

})();
